import styles from './FJTranscribe.module.less';
import FJLocalStore from '../../../../../store/FJLocalStore.js';
import FJButton from '../../../../../common/components/FJButton/FJButton.jsx';
import LoadingBK from '../../../../../assets/svg/transcribe/loading-bg.svg?react';
import LoadingIcon from '../../../../../assets/svg/transcribe/loading.svg?react';
import FJLeftPanelHeader from '../../../common/FJLeftPanelHeader.jsx';

const FJTranscribe = props => {
    // eslint-disable-next-line react/prop-types
    const { onCancel } = props;
    return (
        <div className={styles.box}>
            <FJLeftPanelHeader text={FJLocalStore._('ai-text-based-editing')} onClick={onCancel} />
            <div className={styles.content}>
                <div className={styles.loading_icon_box}>
                    <LoadingBK />
                    <LoadingIcon className={styles.loading_icon} />
                </div>
                <div className={styles.desc}>{FJLocalStore._('transcribing')}</div>
                <FJButton className={styles.button} text={FJLocalStore._('cancel')} onClick={onCancel} />
            </div>
        </div>
    );
};

export default FJTranscribe;
